import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiArrowRight, FiPhone, FiMapPin } = FiIcons;

const OfferSection = () => {
  return (
    <section className="py-16 relative bg-gradient-to-br from-black to-gray-900">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="backdrop-blur-xl bg-black/60 rounded-3xl p-8 sm:p-12 border border-orange-500/30 shadow-2xl text-center"
        >
          <motion.h2
            className="text-3xl sm:text-4xl font-bold text-white mb-6"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
          >
            Ready to Escape Ordinary? Your Custom Dream Trip{" "}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-400 via-pink-400 to-yellow-400">
              Starts Here
            </span>
          </motion.h2>

          <motion.p
            className="text-xl text-gray-200 mb-10 max-w-4xl mx-auto leading-relaxed"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            viewport={{ once: true }}
          >
            Tell us your travel dreams—our expert team will deliver a tailored
            itinerary, absolutely free. Prefer to chat? Schedule a no-obligation
            call or visit our Toronto boutique.
          </motion.p>

          <motion.div
            className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-8"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.6 }}
            viewport={{ once: true }}
          >
            <motion.a
              href="https://seetaluxuryescape.pathfndr.io/search/trips#travel"
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{
                scale: 1.05,
                boxShadow: "0 20px 40px rgba(251,146,60,0.4)",
              }}
              whileTap={{ scale: 0.95 }}
              className="bg-gradient-to-r from-orange-500 to-pink-500 text-white px-8 py-4 rounded-full font-semibold text-lg shadow-xl hover:shadow-2xl transition-all duration-300 flex items-center gap-3 justify-center"
            >
              Get My Free Custom Itinerary
              <SafeIcon icon={FiArrowRight} className="text-xl" />
            </motion.a>

            <motion.a
              href="https://magical-kashata-aac293.netlify.app/#/contact"
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{
                scale: 1.05,
                boxShadow: "0 20px 40px rgba(255,255,255,0.2)",
              }}
              whileTap={{ scale: 0.95 }}
              className="bg-white/20 backdrop-blur-lg text-white px-8 py-4 rounded-full font-medium text-lg border border-white/40 hover:bg-white/30 transition-all duration-300 flex items-center gap-3 justify-center"
            >
              <SafeIcon icon={FiPhone} className="text-xl" />
              Book a Free Consultation
            </motion.a>
          </motion.div>

          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.8 }}
            viewport={{ once: true }}
            className="flex items-center justify-center gap-2 text-orange-200"
          >
            <SafeIcon icon={FiMapPin} className="text-lg" />
            <span>Visit our Toronto boutique for in-person consultations</span>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default OfferSection;